import React from 'react';
export const Diamond = ({ xRef, ...props }) => (
  <svg viewBox="0 0 15 15" {...props} ref={xRef}>
    <path d="M0 7.5L7.5 0L15 7.5L7.5 15L0 7.5Z" />
  </svg>
);
